import { createModuleStore } from '../utils'

export const useSitesStore = createModuleStore(
  'sites',
  {
    type: 'Site',
    noHistory: true,
    sortingOn: 'toolbar',
    pageHeading: 'Sites',
    statusesFilterName: 'statuses',
    uri: '/sites',
    serviceUri: '/sites',
    uploadOptionsCsv: '',
    listingModuleName: 'Config',
    listingActivityName: 'View Site',
    formModuleName: 'Config',
    formActivityName: 'Edit Site',
    allFields: [
      {
        key: 'name',
        title: 'NAME',
        visible: true,
        sortable: true,
        disabled: false,
      },
      {
        key: 'deviceAlertConfigOverrideStrategy',
        title: 'ALERT CONFIG STRATEGY',
        visible: true,
        sortable: true,
        disabled: false,
      },
      {
        key: 'itemDurations',
        title: 'TAG DURATIONS (SECONDS)',
        visible: true,
        sortable: false,
        disabled: true,
      },
      {
        key: 'deviceAlertDurations',
        title: 'DEVICE ALERT DURATIONS (HOURS)',
        visible: true,
        sortable: false,
        disabled: true,
      },
      {
        key: 'deviceUnseenAlertDurations',
        title: 'UNSEEN',
        parent: 'deviceAlertDurations',
        visible: true,
        sortable: false,
        disabled: true,
      },
      {
        key: 'deviceUnusedAlertDurations',
        title: 'UNUSED',
        parent: 'deviceAlertDurations',
        visible: true,
        sortable: false,
        disabled: true,
      },
      {
        key: 'transitDurationMillis',
        title: 'TRANSITION',
        type: 'millisToSecond',
        parent: 'itemDurations',
        visible: true,
        sortable: true,
        disabled: false,
      },
      {
        key: 'dwellDurationMillis',
        title: 'DWELL',
        type: 'millisToSecond',
        parent: 'itemDurations',
        visible: true,
        sortable: true,
        disabled: false,
      },

      {
        key: 'deviceNotSeenAlertMillis',
        title: 'INITIAL',
        type: 'millisToHour',
        parent: 'deviceUnseenAlertDurations',
        visible: true,
        sortable: true,
        disabled: false,
      },
      {
        key: 'deviceNotSeenRetryMillis',
        title: 'RETRY',
        parent: 'deviceUnseenAlertDurations',
        type: 'millisToHour',
        visible: true,
        sortable: true,
        disabled: false,
      },
      {
        key: 'deviceNotUsedAlertMillis',
        title: 'INITIAL',
        parent: 'deviceUnusedAlertDurations',
        type: 'millisToHour',
        visible: true,
        sortable: true,
        disabled: false,
      },
      {
        key: 'deviceNotUsedRetryMillis',
        title: 'RETRY',
        parent: 'deviceUnusedAlertDurations',
        type: 'millisToHour',
        visible: true,
        sortable: true,
        disabled: false,
      },
      {
        key: 'createdBy',
        title: 'CREATED BY',
        visible: false,
        sortable: true,
        disabled: false,
      },
      {
        key: 'createdTimestamp',
        title: 'CREATED TIME',
        visible: false,
        type: 'datetime',
        sortable: true,
        disabled: false,
      },
      {
        key: 'lastModifiedBy',
        title: 'LAST MODIFIED BY',
        visible: false,
        sortable: true,
        disabled: false,
      },
      {
        key: 'lastModifiedTimestamp',
        title: 'LAST MODIFIED TIME',
        visible: false,
        type: 'datetime',
        sortable: true,
        disabled: false,
      },
      {
        key: 'status',
        title: 'STATUS',
        visible: true,
        sortable: true,
        disabled: false,
      },
      {
        key: 'actions',
        title: 'ACTIONS',
        visible: true,
        disabled: true,
        sortable: false,
      },
    ],
  },
  {},
  {
    copy(item) {
      const obj = {
        deviceAlertConfigOverrideStrategy: item.deviceAlertConfigOverrideStrategy,
        dwellDurationMillis: item.dwellDurationMillis,
        transitDurationMillis: item.transitDurationMillis,
        deviceNotSeenAlertMillis: item.deviceNotSeenAlertMillis,
        deviceNotUsedAlertMillis: item.deviceNotUsedAlertMillis,
        deviceNotSeenRetryMillis: item.deviceNotSeenRetryMillis,
        deviceNotUsedRetryMillis: item.deviceNotUsedRetryMillis,
      }
      return obj
    },
    resetPageFilters() {
      const store = useSitesStore()
      store.resetBaseFilters()
    },
  },
  {
    fields: [
      {
        id: 'sites_name',
        name: 'name',
        label: 'Name',
        size: 12,
        component: 'NInput',
        componentProps: { placeholder: 'Enter descriptive site name' },
        rules: [
          {
            required: true,
            trigger: ['blur', 'input'],
          },
          {
            trigger: 'blur',
            remoteValidator: 'isNameUnique',
          },
        ],
      },
      {
        id: 'sites_alert_config_strategy',
        name: 'deviceAlertConfigOverrideStrategy',
        label: 'Alert Config Strategy',
        size: 12,
        component: 'NSelect',
        defaultValue: 'SITE',
        componentProps: {
          multiple: false,
          placeholder: 'Please select a suitable alert config strategy.',
          optionsData: [
            { value: 'SITE', label: 'SITE' },
            { value: 'READZONE', label: 'READZONE' },
            { value: 'READER', label: 'READER' },
          ],
        },
        rules: [
          {
            required: true,
            trigger: ['blur', 'input'],
          },
        ],
      },
      {
        id: 'sites_dwell_duration_millis',
        name: 'dwellDurationMillis',
        label: 'Dwell Duration',
        size: 6,
        component: 'ArsTimeInput',
        defaultValue: 1000,
        componentProps: {
          submitAs: 'millis',
          showAs: 'seconds',
        },
        rules: [
          {
            required: true,
            type: 'number',
            trigger: ['blur', 'input'],
          },
          {
            trigger: 'blur',
            type: 'number',
            customValidator: 'durationValidator',
          },
        ],
      },
      {
        id: 'sites_transit_duration_millis',
        name: 'transitDurationMillis',
        label: 'Transition Duration',
        size: 6,
        defaultValue: 10000,
        component: 'ArsTimeInput',
        componentProps: {
          submitAs: 'millis',
          showAs: 'seconds',
        },
        rules: [
          {
            required: true,
            type: 'number',
            trigger: ['blur', 'input'],
          },
          {
            type: 'number',
            customValidator: 'durationValidator',
            trigger: 'blur',
          },
        ],
      },
      {
        id: 'sites_device_not_seen_alert_millis',
        name: 'deviceNotSeenAlertMillis',
        label: 'Device Unseen Alert Duration',
        size: 6,
        defaultValue: 86400000,
        component: 'ArsTimeInput',
        componentProps: {
          submitAs: 'millis',
          showAs: 'hours',
        },
        rules: [
          {
            required: true,
            type: 'number',
            trigger: ['blur', 'input'],
          },
          {
            type: 'number',
            customValidator: 'durationValidator',
            trigger: 'blur',
          },
        ],
      },
      {
        id: 'sites_device_not_seen_retry_millis',
        name: 'deviceNotSeenRetryMillis',
        label: 'Device Unseen Retry Duration',
        size: 6,
        defaultValue: 86400000,
        component: 'ArsTimeInput',
        componentProps: {
          submitAs: 'millis',
          showAs: 'hours',
        },
        rules: [
          {
            required: true,
            type: 'number',
            trigger: ['blur', 'input'],
          },
          {
            type: 'number',
            customValidator: 'durationValidator',
            trigger: 'blur',
          },
        ],
      },
      {
        id: 'sites_device_not_used_alert_millis',
        name: 'deviceNotUsedAlertMillis',
        label: 'Device Unused Alert Duration',
        size: 6,
        defaultValue: 86400000,
        component: 'ArsTimeInput',
        componentProps: {
          submitAs: 'millis',
          showAs: 'hours',
        },
        rules: [
          {
            required: true,
            type: 'number',
            trigger: ['blur', 'input'],
          },
          {
            type: 'number',
            customValidator: 'durationValidator',
            trigger: 'blur',
          },
        ],
      },
      {
        id: 'sites_device_not_used_retry_millis',
        name: 'deviceNotUsedRetryMillis',
        label: 'Device Unseen Retry Duration',
        size: 6,
        defaultValue: 86400000,
        component: 'ArsTimeInput',
        componentProps: {
          submitAs: 'millis',
          showAs: 'hours',
        },
        rules: [
          {
            required: true,
            type: 'number',
            trigger: ['blur', 'input'],
          },
          {
            type: 'number',
            customValidator: 'durationValidator',
            trigger: 'blur',
          },
        ],
      },
    ],
  }
)
